import { getApi, postApi, putApi } from "../../common/http-clients";
const apiUrl = process.env.REACT_APP_API_URL;

export const submitAPI = async (body) => {
  try {
    const response = await postApi(apiUrl + `vehicle`, body);
    console.log("change", response);
    return response;
  } catch (err) {
    console.error("Error fetching category:", err);

    if (err.response && err.response.data) {
      return err.response;
    } else {
      return { data: { success: false, message: err.message } };
    }
  }
};
export const getVehicleNoDetAPI = async (body) => {
  try {
    const response = await postApi(apiUrl + `vehicle/get_details`, body);
    console.log("change", response);
    return response;
  } catch (err) {
    console.error("Error fetching category:", err);

    if (err.response && err.response.data) {
      return err.response;
    } else {
      return { data: { success: false, message: err.message } };
    }
  }
};
export const getEparivahanAPI = async () => {
  try {
    const response = await getApi(apiUrl + `vehicle/api_integration_enable`);
    return response;
  } catch (err) {
    console.error("Error fetching category:", err);
    if (err.response && err.response.data) {
      return err.response;
    } else {
      return { data: { success: false, message: err.message } };
    }
  }
};
export const getVehicleNoAPI = async (id, params) => {
  try {
    const response = await getApi(apiUrl + `vehicle/history_list/` + id, params);
    console.log("change", response);
    return response;
  } catch (err) {
    console.error("Error fetching category:", err);
    if (err.response && err.response.data) {
      return err.response;
    } else {
      return { data: { success: false, message: err.message } };
    }
  }
};
export const UpdateAPI = async (body, id) => {
  try {
    const response = await putApi(apiUrl + `vehicle/` + id, body);
    console.log("change", response);
    return response;
  } catch (err) {
    console.error("Error fetching category:", err);

    if (err.response && err.response.data) {
      return err.response;
    } else {
      return { data: { success: false, message: err.message } };
    }
  }
};

export const refreshVehicleHistoryAPI = async (vehicleNumber) => {
  try {
    const response = await postApi(apiUrl + `vehicle/refresh_history`, {
      vehicle_number: vehicleNumber,
    });
    return response;
  } catch (err) {
    console.error("Error refreshing vehicle history:", err);
    if (err.response && err.response.data) {
      return err.response;
    } else {
      return { data: { success: false, message: err.message } };
    }
  }
};

export const getMaintenCategApi = async () => {
  try {
    const response = await getApi(apiUrl + `get_maintenance_category`);
    console.log("change", response);
    return response;
  } catch (err) {
    console.error("Error fetching category:", err);

    if (err.response && err.response.data) {
      return err.response;
    } else {
      return { data: { success: false, message: err.message } };
    }
  }
};
export const getCategoryField = async (id) => {
  try {
    const response = await getApi(apiUrl + `get_fields/${id}`);
    console.log("change", response);
    return response;
  } catch (err) {
    console.error("Error fetching category:", err);

    if (err.response && err.response.data) {
      return err.response;
    } else {
      return { data: { success: false, message: err.message } };
    }
  }
};

export const getVehicleEditDetAPI = async (id) => {
  try {
    const response = await getApi(apiUrl + `vehicle/edit/${id}`);
    console.log("change", response);
    return response;
  } catch (err) {
    console.error("Error fetching category:", err);

    if (err.response && err.response.data) {
      return err.response;
    } else {
      return { data: { success: false, message: err.message } };
    }
  }
};

export const saveAttachmentApi = async (id, body) => {
  try {
    const response = await putApi(apiUrl + `vehicle/add_attachment/` + id, body);
    console.log("change", response);
    return response;
  } catch (err) {
    console.error("Error fetching category:", err);

    if (err.response && err.response.data) {
      return err.response;
    } else {
      return { data: { success: false, message: err.message } };
    }
  }
};
